// version: 1.1.6.0

import React, { useState, useCallback, useEffect, useRef } from "react";
import _ from "lodash";
import { DropDown, InputCheckboxRadio, SingleCheckbox } from "../../forms";
// import StateView from "../../utils/StateView";
import { Loader } from "../../atoms";
import {
  _getBaseUrl,
  isAllOptionsSelected,
  _getCSRFTokenValue,
} from "../../utils/helper";
import api from "../../utils/api";

const INITIAL_VALUES = {
  year: [],
  electionType: [],
  challengeType: [],
  region: [],
};

const GlobalElectionMonitor = (props) => {
  const [yearOptions, setYearOptions] = useState([]);
  const [challengeTypeOptions, setChallengeTypeOptions] = useState([]);
  const [electionTypeOptions, setElectionTypeOptions] = useState([]);
  const [regionOptions, setRegionOptions] = useState([]);
  const [values, setValues] = useState(INITIAL_VALUES);
  const [selectedTags, setSelectedTags] = useState([]);
  const [isLoadingPosts, setIsLoadingPosts] = useState(false);

  let filterOptions = [];

  useEffect(() => {
    const element = document.getElementById("filter-options-data");
    const dataYear = element.getAttribute("data-year");
    setYearOptions(JSON.parse(dataYear));

    const dataElectionType = element.getAttribute("data-election-type");
    setElectionTypeOptions(JSON.parse(dataElectionType));

    const dataChallengeType = element.getAttribute("data-attr-type");
    setChallengeTypeOptions(JSON.parse(dataChallengeType));

    const dataRegion = element.getAttribute("data-region");
    setRegionOptions(JSON.parse(dataRegion));
  }, []);

  useEffect(() => {
    // fetchPosts();
    const mapDataDiv = document.getElementById('edb-map-data');
    mapDataDiv.setAttribute('data-map-data', JSON.stringify(values));
  }, [values]);

  const saveSelectedTags = (type, selectedValues, options) => {
    const clone = selectedTags.slice();

    let temp = [];

    clone.map((item) => {
      if (item.type !== type) {
        temp.push(item);
      }
      // If type is same, check if value is already in selectedTags
      if (item.type === type) {
        const val = item.value;

        if (selectedValues.includes(val)) {
          temp.push(item);
        }
      }
    });

    selectedValues.map((A) => {
      const find = temp.filter((B) => {
        return A === B.value && B.type === type;
      });

      // If value is not in selectedTags, add it
      if (find.length === 0) {
        const opt = options.filter((C) => {
          return A === C.value;
        });

        temp.push({
          type: type,
          value: A,
          label: type === "year" ? A : opt[0].label,
        });
      }
    });

    setSelectedTags(temp);
  };

  const removeTag = (tag) => {
    const newTypeValues = values[tag.type].filter((item) => {
      return item !== tag.value;
    });

    setValues({
      ...values,
      [tag.type]: newTypeValues,
    });

    let options;

    if (tag.type === "year") { options = yearOptions; }
    if (tag.type === "electionType") { options = electionTypeOptions; }
    if (tag.type === "challengeType") { options = challengeTypeOptions; }

    saveSelectedTags(tag.type, newTypeValues, options);
  };

  const clearAll = () => {
    setValues(INITIAL_VALUES);
    setSelectedTags([]);
  }

  const fetchPosts = async () => {
    setIsLoadingPosts(true);

    const data = {
      briefType: "INHE",
      year: values.year,
      electionType: values.electionType,
      challengeType: values.challengeType,
    };

    const csrfToken = await _getCSRFTokenValue();

    api
      .post("/electionsdashboardbrief/searchandfilter", data, {
        headers: {
          "X-CSRF-Token": csrfToken,
        },
      })
      .then((res) => {
        setIsLoadingPosts(false);

        // const mapDataDiv = document.getElementById('edb-map-data');
        // mapDataDiv.setAttribute('data-map-data', JSON.stringify(res.data));
      })
      .catch(() => {
        setIsLoadingPosts(false);
      });
  };

  return (
    <div className="relative">
      <div className="grid gap-4">
        <div className="grid grid-cols-12 gap-2">
          <div className="col-span-4 lg:col-span-2 xl:col-span-2">
            <OptionsFilter
              options={yearOptions}
              label="Year"
              type="year"
              values={values}
              setValues={setValues}
              selectedTags={selectedTags}
              setSelectedTags={setSelectedTags}
              saveSelectedTags={saveSelectedTags}
              placeholder="Select here"
            />
          </div>
          <div className="col-span-4 lg:col-span-4 xl:col-span-3">
            <OptionsFilter
              options={regionOptions}
              label="Region"
              type="region"
              values={values}
              setValues={setValues}
              selectedTags={selectedTags}
              setSelectedTags={setSelectedTags}
              saveSelectedTags={saveSelectedTags}
              placeholder="Select here"
            />
          </div>
          {/* <div className="col-span-3 lg:col-span-3 xl:col-span-3">
            <OptionsFilter
              options={electionTypeOptions}
              label="Election Type"
              type="electionType"
              values={values}
              setValues={setValues}
              selectedTags={selectedTags}
              setSelectedTags={setSelectedTags}
              saveSelectedTags={saveSelectedTags}
              placeholder="Select here"
            />
          </div> */}
          <div className="col-span-4 lg:col-span-6 xl:col-span-7">
            <AttrTypeFilter
              options={challengeTypeOptions}
              values={values}
              setValues={setValues}
              selectedTags={selectedTags}
              setSelectedTags={setSelectedTags}
              saveSelectedTags={saveSelectedTags}
            />
          </div>
        </div>

        <div>
          <div className="flex flex-wrap gap-2">
            {selectedTags.map((item, index) => {
              return <FilterTag tag={item} key={index} removeTag={removeTag} />;
            })}

            {selectedTags.length > 0 && (
              <div
                className="btn btn-c--hollow---black whitespace-nowrap !flex gap-4 items-center"
                onClick={() => {
                  clearAll();
                }}
              >
                <span>Clear all</span>
              </div>
            )}

            {isLoadingPosts && (
              <div className="flex px-4 items-center justify-center">
                <Loader />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* <StateView
        title="Values"
        values={values}
        class="fixed bottom-4 left-4 right-[unset]"
        floating
      />

      <StateView
        title="Selected Tags"
        values={selectedTags}
        class="fixed bottom-4 !right-1/2 translate-x-1/2 left-[unset]"
        floating
      /> */}
    </div>
  );
};

const OptionsFilter = ({
  options,
  label,
  type,
  values,
  setValues,
  selectedTags,
  setSelectedTags,
  saveSelectedTags,
  placeholder,
  ...props
}) => {
  return (
    <div>
      <div className="font-bold mb-2">
        <label htmlFor="year">{label}</label>
      </div>
      <DropDown placeholder={placeholder}>
        <div>
          <SingleCheckbox
            label="All"
            onChange={(v) => {
              if (v) {
                const newValues = options.map((item) => item.value);
                setValues({
                  ...values,
                  [type]: newValues,
                });
                saveSelectedTags(type, newValues, options);
              } else {
                setValues({
                  ...values,
                  [type]: [],
                });
                saveSelectedTags(type, [], options);
              }
            }}
            value={isAllOptionsSelected(
              options.map((item) => item.value),
              values[type]
            )}
          />
          <InputCheckboxRadio
            name={type}
            type="checkbox"
            options={options}
            value={values[type]}
            onChange={(v) => {
              setValues({
                ...values,
                [type]: v,
              });
              saveSelectedTags(type, v, options);
            }}
            itemClass="mb-2"
          />
        </div>
      </DropDown>
    </div>
  );
};

const AttrTypeFilter = ({
  options,
  values,
  setValues,
  selectedTags,
  setSelectedTags,
  saveSelectedTags,
  placeholder,
  ...props
}) => {
  return (
    <div>
      <div className="font-bold mb-2">
        <label htmlFor="year">Electoral Integrity Challenge</label>
      </div>
      <DropDown placeholder="Select here" maxHeight={"auto"}>
        <div>
          <div className="py-4">
            <div className="grid grid-cols-1 gap-4 lg:gap-4 tema-form">
              <div className="">
                <SingleCheckbox
                  label="All"
                  onChange={(v) => {
                    if (v) {
                      const newValues = options.map((item) => item.value);
                      setValues({
                        ...values,
                        challengeType: newValues,
                      });
                      saveSelectedTags("challengeType", newValues, options);
                    } else {
                      setValues({
                        ...values,
                        challengeType: [],
                      });
                      saveSelectedTags("challengeType", [], options);
                    }
                  }}
                  value={isAllOptionsSelected(
                    options.map((item) => item.value),
                    values.challengeType
                  )}
                />
              </div>
              {options.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="flex items-center justify-start gap-4"
                  >

                    <input
                      type="checkbox"
                      id={`attr-${index}`}
                      className="checkbox"
                      value={item.value}
                      checked={
                        values.challengeType.includes(item.value) ? "checked" : ""
                      }
                      onChange={(e) => {
                        let v = item.value;
                        let temp = [...values.challengeType];

                        if (!temp.includes(v)) {
                          const newValues = [...temp, item.value];

                          setValues({
                            ...values,
                            challengeType: newValues,
                          });

                          saveSelectedTags("challengeType", newValues, options);
                        } else {
                          temp = temp.filter((item) => item !== v);

                          setValues({
                            ...values,
                            challengeType: temp,
                          });

                          saveSelectedTags("challengeType", temp, options);
                        }
                      }}
                    />

                    <label htmlFor={`attr-${index}`} className="flex-shrink-0"></label>

                    <label htmlFor={`attr-${index}`} className="block !px-0 flex-shrink-0">
                      <img
                        src={item.image}
                        alt="item.label"
                        className="w-[48px] lg:w-[60px] cursor-pointer"
                      />
                    </label>

                    <label htmlFor={`attr-${index}`} className="!p-0 text-sm lg:text-base">
                      {item.label}
                    </label>


                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </DropDown>
    </div>
  );
};

const FilterTag = ({ tag, removeTag }) => {
  return (
    <div>
      <div className={`election-dashboard--filter---selected-tag ${tag.type}`}>
        <span>{tag.label}</span>
        <img
          src={_getBaseUrl("src/assets/icons/icon-close-dark.svg", true)}
          alt="toggle download"
          className="filter invert"
          onClick={() => {
            removeTag(tag);
          }}
        />
      </div>
    </div>
  );
};

export default GlobalElectionMonitor;
